export default __webpack_public_path__ + "static/media/qa.e11d277a.png";